import React from "react";

function SvgIcMapPoi057(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M16 24a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0116 24zm3.167-4.666a1.833 1.833 0 110 3.665 1.833 1.833 0 010-3.665zm-6.333 0a1.833 1.833 0 110 3.665 1.833 1.833 0 010-3.665zM22 14a2 2 0 11.001 3.999A2 2 0 0122 14zm-6 0a2 2 0 11.001 3.999A2 2 0 0116 14zm-6 0a2 2 0 11.001 3.999A2 2 0 0110 14zm3-4a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0113 10zm10.193-2.194a4.126 4.126 0 01-1.066 3.987 4.125 4.125 0 01-3.987 1.067 4.122 4.122 0 015.053-5.053zM16 4c.51 0 .935.388.993.884L17 5c0 .534-.424 5.684-.952 5.986L16 11c-.534 0-.973-5.134-.999-5.939L15 5c0-.51.388-.935.884-.993L16 4z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi057;
